import React, { useEffect, useState } from "react";
import { theme } from 'common/selectCustomStyles';
import {benchmarkingMilestoneSystems} from "services/listServices";
import Select from "react-select";

function SystemsDropdown({systemID, setSystemID}) {

    const [systems, setSystems] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        setSystemID(selectedOption.value);
    };

    useEffect(()=>{
        const fetchSystems = async () => {
            try{
                setIsLoading(true);
                let systemList = await benchmarkingMilestoneSystems();
                if (systemList && systemList.length > 0) {
                    // Format systems for react-select
                    const allSystemsOption = { value: 0, label: "All systems" };
                    const formattedSystems = [
                        allSystemsOption,
                        ...systemList.map(system => ({
                            value: system?.system_id,
                            label: system?.system_name
                        }))
                    ];
                    setSystems(formattedSystems);

                    // Set default selected option
                    if (systemID) {
                        const selected = formattedSystems.find(option => option.value === systemID);
                        if (selected) {
                            setSelectedOption(selected);
                        }
                    } else {
                        setSelectedOption(allSystemsOption);
                    }
                }
            } catch(error) {
                console.error("Failed to fetch systems!", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchSystems();

    }, [])

    return (
        <Select
            options={systems}
            value={selectedOption}
            className={`basic-single`}
            isLoading={isLoading}
            classNamePrefix="select"
            theme={theme}
            onChange={handleChange}
            styles={{
                container: (provided) => ({
                    ...provided,
                    width: "auto",
                    minWidth: "160px"
                }),
            }}
        />
    );
}

export default SystemsDropdown;